import React from "react";
import { Link, useSearchParams } from "react-router-dom";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const quoteCode = searchParams.get("quote");

  return (
    <main className="section">
      <div className="container">
        <div className="contact-box">
          <div className="contact-text">
            <span className="section-label">Payment Successful</span>

            <h2>Thank you. Your payment has been received.</h2>

            <p>
              Your payment was completed successfully. We will now review your
              translation request and contact you by email.
            </p>

            {quoteCode && (
              <p>
                <strong>Quote reference:</strong> {quoteCode}
              </p>
            )}

            <Link to="/" className="btn btn-primary">
              Back to Website
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}